import { IRegisterData } from "../../repository/IRegisterData";

export const registerUser = (payload: IRegisterData) => ({
  type: "@saga/REGISTER",
  payload,
});
